module.exports = __webpack_public_path__ + "02_veryshort_black.4053017a.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer5/02_veryshort_black.png
// module id = hIJN
// module chunks = 0